/**
 * Composio CDN logo URL for a toolkit slug.
 * Prefer this over API `meta.logo` — some third-party logo URLs are broken while the CDN works.
 * @param toolkitSlug Composio toolkit slug (e.g. `github`).
 * @param theme Optional CDN theme (`dark` for dark surfaces).
 * @returns Absolute logo URL.
 */
export function composioToolkitLogoUrl(toolkitSlug: string, theme?: 'dark'): string {
  const slug = toolkitSlug.trim().toLowerCase();
  const base = `https://logos.composio.dev/api/${encodeURIComponent(slug)}`;
  return theme === 'dark' ? `${base}?theme=dark` : base;
}
